import './index.css';

const CustomerProposals = () => {
  return (
    <section className="customer-proposals-page">
      <div className="customer-proposals-header">
        <p>Member proposals</p>
        <h1>Your Hogcloud proposals.</h1>
        <span>Secure project proposals and documents will appear here when available.</span>
      </div>

      <div className="customer-proposals-empty">
        <h2>No proposals yet.</h2>
        <p>
          When Hogcloud prepares a proposal for your account, it will be listed here
          with secure document access.
        </p>
      </div>
    </section>
  );
};

export default CustomerProposals;
